import { LanguageId } from "../../../../types/language";
import { NotebookActionKey } from "../../../actions/ActionKeys";
import { NotebookAction } from "../../../actions/notebook";

/** Language reducer. */
export const languageId = (
  state: LanguageId | null = null,
  action: NotebookAction
): LanguageId | null => {
  switch (action.type) {
    case NotebookActionKey.SET_DRAFT_SPEC:
      // TODO(cochamberlain): Map usage over to generic entities.
      return action.payload.draftSpec.languageId;
    case NotebookActionKey.SET_CURRENT_LANGUAGE_ID:
      return action.payload.languageId;
    default:
      return state;
  }
};
